<ng-container *ngIf="reversalForm">
	<div class="row">
		<div class="col-md-12">
			<h5 class="mb-3">Payment Reversal</h5>
			<form [formGroup]="reversalForm">
				<div class="row">
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Transaction Date</mat-label>
							<input matInput [matDatepicker]="picker" formControlName="date">
							<mat-hint>MM/DD/YYYY</mat-hint>
							<mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
							<mat-datepicker #picker></mat-datepicker>
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Amount</mat-label>
							<input matInput formControlName="amount" />
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Location</mat-label>
							<mat-select formControlName="location">
								<mat-option [value]="''">Use original location</mat-option>
								<mat-option *ngFor="let loc of locations" [value]="loc.loccode">
									{{loc.loccode}} - {{loc.locationname}}
								</mat-option>
							</mat-select>
						</mat-form-field>
					</div>
					<div class="col-md-3">
						<mat-form-field appearance="fill" class="w-100">
							<mat-label>Reason</mat-label>
							<input matInput formControlName="reason" placeholder="Reason for reversal">
						</mat-form-field>
					</div>
				</div>
				<div class="row mt-2">
					<div class="col-md-12 d-flex align-items-center gap-3">
						<button mat-raised-button color="accent" (click)="createRefund()">Reverse Payment</button>
						<mat-slide-toggle formControlName="card">Refund Card</mat-slide-toggle>
					</div>
				</div>
				<div class="row mt-3" *ngIf="reversalForm.get('card')?.value">
					<div class="col-12 gateway-ref-panel">
						<ng-container *ngIf="isCardpointeGateway()">
							<div class="text-muted small mb-1">CardPointe / CardConnect refund uses this <strong>retref</strong> (POST <code>refund</code> → <code>retref</code>):</div>
							<div class="d-flex align-items-center flex-wrap gap-2">
								<code class="gateway-ref-code">{{ refundGatewayTransactionId || '— none resolved —' }}</code>
								<mat-icon *ngIf="refundCardpointeRetrefValid === true" class="gateway-ref-ok" matTooltip="Matches CardPointe retref pattern (numeric, 8+ digits)">check_circle</mat-icon>
								<mat-icon *ngIf="refundCardpointeRetrefValid === false" class="gateway-ref-warn" matTooltip="Not a valid retref; gateway refund will fail until payby_comments or capture.transactionid holds the original retref">warning</mat-icon>
							</div>
							<div class="text-muted small mt-1" *ngIf="refundGatewayIdSource === 'capture'">Resolved from <code>capture</code> table (matched amount / customer).</div>
						</ng-container>
						<ng-container *ngIf="isStripeGateway()">
							<div class="text-muted small mb-1">Stripe refund uses this <strong>Payment Intent</strong> id:</div>
							<code class="gateway-ref-code">{{ refundGatewayTransactionId || '— none resolved —' }}</code>
							<div class="text-muted small mt-1" *ngIf="refundGatewayIdSource === 'capture'">Resolved from <code>capture</code> table.</div>
						</ng-container>
						<ng-container *ngIf="refundGateway && !isCardpointeGateway() && !isStripeGateway()">
							<div class="text-muted small mb-1">Gateway <strong>{{ refundGateway }}</strong> — adapter transaction reference:</div>
							<code class="gateway-ref-code">{{ refundGatewayTransactionId || '— none resolved —' }}</code>
						</ng-container>
						<ng-container *ngIf="!refundGateway">
							<div class="text-muted small mb-1">Payment gateway not configured; card refund behaviour depends on server.</div>
						</ng-container>
					</div>
				</div>
			</form>
		</div>
	</div>
</ng-container>
